// test79
(79 && 0);
